import { render, staticRenderFns } from "./fornecedorrepresentantelegal.vue?vue&type=template&id=27c355ca"
import script from "./fornecedorrepresentantelegal.vue?vue&type=script&lang=js"
export * from "./fornecedorrepresentantelegal.vue?vue&type=script&lang=js"
import style0 from "./fornecedorrepresentantelegal.vue?vue&type=style&index=0&id=27c355ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports